import { useEffect } from 'react';
import { AnalyticsData, useAnalytics } from './useAnalytics.tsx';

export type EmitAnalyticsEventProps = {
  event: string;
  data?: AnalyticsData;
};

/**
 * Helper to emit an analytics event a single time when a component mounts.
 * See useAnalyticsEvent for the hook equivalent of this component
 */
export function EmitAnalyticsEvent({ event, data }: EmitAnalyticsEventProps) {
  const analytics = useAnalytics();

  useEffect(() => {
    analytics.track(event, data);
  }, []); // Caution -- seems unsafe to put `data` in deps (obj identity may change each render)

  return <></>;
}
